// extracted by mini-css-extract-plugin
export default {"documentIcon":"_7486261d5a50e80b","documentIconUploaded":"f746c1e158c34115","documentIconNotUploaded":"bb3277ab67c613a1","tinyButton":"_08f734008b010389","block":"_5031ff6e10eac791"};